/**
 * Superadmin 2FA adapters (ADR-0036 F2.0) — the transport seam the SHARED `TotpAdapter`
 * UI (`components/auth/totp.tsx`) runs on, over the platform fetch wrapper.
 *
 * `platformTotpAdapter` uses the logged-in platform session (the Security page);
 * `platformSetupAdapter(setupToken)` injects a forced-enrollment token as the Bearer
 * (login has no session yet — the password step handed back a `totp_setup` token). The
 * backend `confirm` returns `{token}`; the shared `TotpConfirmed` expects `access_token`,
 * so we remap it (a forced-setup confirm opens the session from that token).
 */
import type { TotpAdapter, TotpConfirmed } from "@/components/auth/totp";
import { platformApi } from "./platform";

function toConfirmed(r: { recovery_codes: string[]; token: string }): TotpConfirmed {
  return { recovery_codes: r.recovery_codes, access_token: r.token };
}

export const platformTotpAdapter: TotpAdapter = {
  status: () => platformApi.totpStatus(),
  begin: () => platformApi.totpBegin(),
  confirm: (code) => platformApi.totpConfirm(code).then(toConfirmed),
  disable: (code) => platformApi.totpDisable(code),
};

/** Enroll using a forced-setup token as the Bearer (no session yet). Status / disable are
 *  unreachable in this flow, so they no-op / throw. */
export function platformSetupAdapter(setupToken: string): TotpAdapter {
  return {
    status: async () => ({ enabled: false, recovery_codes_remaining: 0 }),
    begin: () => platformApi.totpBegin(setupToken),
    confirm: (code) => platformApi.totpConfirm(code, setupToken).then(toConfirmed),
    disable: async () => {},
  };
}
